/**
 * @type module
 * Komunikuje się z serwerem w celu pobrania danych i zwraca listę obecnie wybranych lokalizacji,
 * w tablicy locationsData przechowywane są wszystkie pobrane lokalizacje
 */

app.service('shopLocatorManager', function( shopLocatorFilters, console, loading ) {

	var locationsData = [];

	function get( pointType, data ) {
		var params = $.extend({ pointType: pointType }, data);
		return $.ajax({
			url: '/collection-points.ltr',
			dataType: 'json',
			data: params
		});
	}

	function getLocationsByZipCode( pointType, zipCode ) {
		return get( pointType, { zipCode: zipCode } );
	}

	function getLocations( pointType ) {
		if( locationsData[pointType] ) {
			return $.Deferred().resolve( locationsData[pointType] ).promise();
		}
		return get( pointType ).then(function( data ) {
			locationsData[ pointType ] = data;
			return data;
		}).catch(onError);
	}

	function onError(err) {
		console.log( '[AJAX] Something went wrong: ' + err.statusText );
		return err;
	}

	function getVisibleLocations() {
		var locations = [];
		shopLocatorFilters.getSelected().forEach( function( id ) {
			locations = locations.concat( locationsData[ id ] );
		} );
		return locations;
	}

	return {
		getLocations: getLocations,
		getVisibleLocations: getVisibleLocations,
		getLocationsByZipCode: getLocationsByZipCode
	};

});
